import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomArrayValidators {
  static minLength(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (Array.isArray(value)) {
        return value.length >= min
          ? null
          : {
              minArrayLength: {
                requiredLength: min,
                actualLength: value.length
              }
            };
      }

      return null;
    };
  }

  static maxLength(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (Array.isArray(value)) {
        return value.length <= max
          ? null
          : {
              maxArrayLength: {
                requiredLength: max,
                actualLength: value.length
              }
            };
      }

      return null;
    };
  }
}
